import type Phaser from "phaser";
import { FootballSelectScene } from "./football/select";
import { FootballPlayScene } from "./football/play";

type SceneCtor = new () => Phaser.Scene;

export interface GameDef {
  key: string;            // matches the entry scene's key
  name: string;
  description: string;
  icon: string;
  scenes: SceneCtor[];    // first entry is the scene the menu launches
}

export const GAMES: GameDef[] = [
  {
    key: "football",
    name: "Football",
    description: "Subbuteo puzzles. Score in N flicks.",
    icon: "⚽",
    scenes: [FootballSelectScene, FootballPlayScene],
  },
];
